import React, { useState, useEffect } from 'react';
import moment from 'moment';
import swal from 'sweetalert2';
import axios from 'axios';
import DatePicker from 'react-datepicker';
import TextareaAutosize from 'react-autosize-textarea';
import 'react-datepicker/dist/react-datepicker.css';
import '../../../scss/components/pages/signin-management.scss';
import AddWorkTimeInSignInShiftBlock from '../../AddWorkTimeInSignInShiftBlock';
import LeaveRecDetail from '../../LeaveRecDetail';

import API from '../../../middleware/API';
import Pagination from '../../Pagination';
import { connect } from 'react-redux';
import { yearNames,GetStoreRole } from '../../../const/constant';

function MonthHour() {
  //const countOfPage = 10;
  const start = `${moment().add(-1, 'months').format('YYYY-MM')}-01`;
  //const start = moment().add(-8, 'days').format('YYYY-MM-DD');
  const end = moment(start).add(1, 'months').add(-1,'days').format('YYYY-MM-DD');
  const [currPage, setCurrPage] = useState(1);
  const [isAddWorkTimeOpen, setIsAddWorkTimeOpen] = useState(false);
  const [reload, doReload] = useState(false);
  const [searchStartDate, setSearchStartDate] = useState(moment(start));
  const [searchEndDate, setSearchEndDate] = useState(moment(end));
  const [editStaff, setEditStaff] = useState({
    expectedDate: moment(),
    expectedStart: moment(),
    expectedEnd: moment(),
  });
  const [isLeaveRecDetailDisplay, toggleLeaveRecDetail] = useState(false);
  const [targetLeaveRec, setTargetLeaveRec] = useState({});
  const [department, setDepartment] = useState('all');
  const [totalDelay, setTotalDelay] = useState('0:0');
  const [totalDelayHour, setTotalDelayHour] = useState(0);
  const [eventId, setEventId] = useState(0);
  const [expectedDateToModify, setExpectedDateToModify] = useState('');

  const [totalDelayMinute, setTotalDelayMinute] = useState(0);
  const [attendance, setAttendance] = useState({ count: 0, records: [] });
  const [isLock, setIsLock] =  useState(true);   
  const [year, setYear] = useState(moment().add(-1,'month').year());
  const [month, setMonth] = useState(moment().add(-1,'month').month());
  const [staffList, setStaffList] = useState([]);
  const [recordList, setRecordList] = useState([]);
  const [searchName, setSearchName] = useState('');
  const [count, setCount] = useState(0);
  const [countOfPage, setCountOfPage] = useState(10);
  const totalPage = Math.ceil(count / countOfPage);
  const [personalSum, setPersonalSum] = useState({});
  const [firstRecord, setFirstRecord] = useState({});
  const role = GetStoreRole(localStorage.getItem('current_store_id')) ;
  const storeId =localStorage.getItem('current_store_id');

  function loadData() {
    const params = {
      timeOffset: 8,
      year: year,
      month: (parseInt(month, 10)+1),
      page: currPage,
      pageSize: countOfPage,
      department: department
    };
    if (searchName) params.keyword = searchName;
    API.get('/Event/AttendanceSheet/SalaryV2', {
      params,
    }).then((response) => {
      if (response) {
        setStaffList(response.userList)
        setRecordList(response.records)
        setPersonalSum(response)
        setFirstRecord(response.records[0]||{})
        setCount(response.count)
        setIsLock(response.isLock)
      }
    });
  }

  useEffect(
    loadData,
    [currPage, searchName, year, month, reload],
  );
  function isInt(n) {
    return n % 1 === 0;
 }
 function dateValidationCheck(str) {
    var re = new RegExp("^([0-9]{1,2})[.:]{1}([0-9]{1,2})$");
    var strDataValue;
    var infoValidation = true;
    if ((strDataValue = re.exec(str)) != null) {
      var i;
      i = parseFloat(strDataValue[1]);
      if (i >= 24) { /*年*/
        infoValidation = false;
      }

      i = parseFloat(strDataValue[2]);
      if (i >= 60) { /*月*/
        infoValidation = false;
      }

    } else {
      infoValidation = false;
    }
    if (!infoValidation) {
      alert("請輸入 00:00~23:59 時間格式");
    }
    return infoValidation;
  }
  function handleDoubleClick(id, field, value, title, fieldChinese, status){
    //取消修改功能
    return;
    if(status)
      return;
    swal({
        type: 'info',
        title : title + '-' + fieldChinese,
        inputValue : value?value:'',
        input:'text',
        showConfirmButton: true,
        showCloseButton: true,
        confirmButtonText: '確定',
        heightAuto: false,
    }).then((data) => {
        if(data.value){

        // your input data object will be usable from here
          if( field == "notes"){
            
          }else
            if (field == "estSignIn"|| field == "estSignOut" || field == "signIn1" || field == "signOut1" ||
            field == "signIn2" || field == "signOut2" || field == "signIn3" || field == "signOut3")
            {
                if(!dateValidationCheck(data.value)){
                    return;
                }
            }else if (field == "totalHours" || field == "overtimeHours" || field == "compensatoryHours" 
                || field == "payHours" ||field == "leaveHours" )
            {
                var x = parseInt(data.value);
                if(isNaN(x)){
                    alert("請輸入數字");
                    return;
                }
            }
            else if (field == "lateMin" || field == "earlyMin" || field == "breakTimeMin"
            || field == "totalHoursH" || field == "totalHoursM" || field == "over134"|| field == "over167"|| field == "over2")
            {
                var x = parseInt(data.value);
                if(isNaN(x)){
                    alert("請輸入數字");
                    return;
                }
            }
            API.put('/Event/AttendanceSheet/SalaryV2?id='+id+'&field='+field+'&value='+data.value).then((response) => {
                swal({
                    type: 'success',
                    title : '修改成功',
                })
                doReload(!reload);
            });
        }

        
    });

  }
  function unlockAllData(){
    API.post('/Event/AttendanceSheet/Unlock?year='+year+'&month='+(parseInt(month, 10)+1)).then((response) => {
      swal({
          type: 'success',
          title : '解鎖成功',
      })
      doReload(!reload);
    });
  }
  function lockAllData(){
    swal({
      type: 'warning',
      title : '鎖定後不可再修改資料',
      showConfirmButton: true,
      showCancelButton: true,
      showCloseButton: true,
      confirmButtonText: '確定',
      cancelButtonText: '取消',
      heightAuto: false,
  }).then((data) => {
        if(data.value){
          API.post('/Event/AttendanceSheet/Lock').then((response) => {
            swal({
                type: 'success',
                title : '鎖定成功',
            })
            doReload(!reload);
        });
        }else{
          console.log('取消');
        }
  });
  }

  function handleSearchStartDateChange(date) {
    setCurrPage(1);
    setSearchStartDate(date);
  }

  function handleSearchEndDateChange(date) {
    setCurrPage(1);
    setSearchEndDate(date);
  }

  function inputSearchChange(e) {
    setCurrPage(1);
    setSearchName(e.target.value);
  }

  function handleSearchButton() {
    setCurrPage(1);
  }

  function handleChangePage(page) {
    setCurrPage(page);
  }
  function deleteSignIn(id, userId) {
    const adminName = localStorage.getItem('adminName') || '';
    swal({
      type: 'error',
      html: '確定刪除排假?<br/>(此動作無法<span style="color:red">復原<span>)',
      showConfirmButton: true,
      showCloseButton: true,
      confirmButtonText: '確定',
      heightAuto: false,
    }).then((result) => {
      if (result.value !== undefined) {
        let objEvent = {
          data: {
            id: `${id}`
          }
        }
        API.delete('Event', objEvent).then((res) => {
          if (res) {
            setSearchName('');
            loadData();
          }
        });
      }
    });
  }


  function rejectSignIn(id, userId) {
    const adminName = localStorage.getItem('adminName') || '';
    swal({
      type: 'info',
      html: '確定退回重簽?',
      inputPlaceholder: '請輸入退回原因(選填)',
      input: 'text',
      showConfirmButton: true,
      showCloseButton: true,
      confirmButtonText: '確定',
      heightAuto: false,
    }).then((result) => {
      if (result.value !== undefined) {
        const data = { eventId: id,userId: userId,  status: 4, comment: result.value ? `${adminName}:${result.value}` : `${adminName}:` };
        API.post('/Event/Update', data).then((response) => {
          if (response) {
            setSearchName('');
            loadData();
          }
        });
      }
    });
  }

  function styleTime(strTime) {
    return <span style={{ color: '#dddddd' }}>{strTime}</span>;
  }

  function styleTotalWorkTime(arrTotalWorkTime) {
    console.log(arrTotalWorkTime);
    const styleHightLight = {
      color: arrTotalWorkTime[0] > 9 ? 'red' : '#4A4A4A',
      fontWeight: arrTotalWorkTime[0] > 9 ? '900' : '400',
      fontSize: arrTotalWorkTime[0] > 9 ? '20px' : '18px',
    };
    const strHour = arrTotalWorkTime[0] < 10
      ? `0${arrTotalWorkTime[0]}`
      : arrTotalWorkTime[0];
    const strMinutes = arrTotalWorkTime[1] < 10
      ? `0${arrTotalWorkTime[1]}`
      : arrTotalWorkTime[1];

    return (
      <span style={styleHightLight}>
        {`${strHour}:${strMinutes}`}
      </span>
    );
  }
  function generateExcel() {
    swal({
      type: 'warning',
      title: '確定更新報表?',
      text: '所有出勤資料將會清除並重新計算。',
      showCloseButton: true,
      heightAuto: false,
      showCancelButton: true,
      showConfirmButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#A9ABA8',
      confirmButtonText: '確定',
      cancelButtonText: '取消',
    }).then((result) => {
      if (result.value) {
        
        API
        .get(process.env.REACT_APP_NODE_ENV === 'development'?'https://www.liangshishu.link:46890/api/app/EmpRemainLeave':'https://www.liangshishu.link:46888/api/app/EmpRemainLeave')
        .then((uploadResponse) => {
          axios({
            url:process.env.REACT_APP_NODE_ENV === 'development'?'https://www.liangshishu.link:46890/api/'+'/Chart/Generate?year='+year+'&month='+(parseInt(month, 10)+1):'https://www.liangshishu.link:46888/api/'+'/Chart/Generate?year='+year+'&month='+(parseInt(month, 10)+1),
            method: 'GET',
            headers:{
  'Authorization': 'bearer ' + localStorage.getItem('access_token'),
        'StoreId':storeId },
        responseType: 'blob'}).then((response) => {
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', '出勤明細'+year+'年'+(parseInt(month, 10)+1)+'月_' + new Date().toLocaleDateString() +'.xlsx'); //or any other extension
            document.body.appendChild(link);
            link.click();
            loadData();
            }).catch((error) => {
            swal.fire({
              type: 'error',
              title: '下載失敗',
            text: error.response && error.response.status === 500 ? '伺服器錯誤，請稍後再試' : '下載報表時發生錯誤',
              heightAuto: false,
            });
          });
        }).catch((error) => {
          swal.fire({
            type: 'error',
            title: '更新失敗',
            text: '更新員工資料時發生錯誤',
            heightAuto: false,
          });
        })


      }
    })

  }


  function handleToggleOpenAddWorkTimeBlock(item) {

    if(item.resourceId === 8 || item.resourceId === 9)
      return;

    var staff = [];
    staff.push(
      {
        realName:item.name,
        expectedDate:item.expectedDate,
        expectedStart:item.expectedSignInTime.length === 0 ? '無':item.expectedSignInTime,
        expectedEnd:item.expectedSignOutTime.length === 0 ? '無':item.expectedSignOutTime,
        
      }
    )
    let newEditHoliday = {
      expectedDate:item.expectedDate,
      expectedStart:item.expectedSignInTime.length === 0 ? '無':item.expectedSignInTime,
      expectedEnd:item.expectedSignOutTime.length === 0 ? '無':item.expectedSignOutTime,
    };
    setEditStaff(
      newEditHoliday
    );

    setStaffList(staff)
    setEventId(item.eventId)
    setExpectedDateToModify(item.expectedDate)
    setIsAddWorkTimeOpen(true)
  }

  function handleAddStaffWorkRecord(item) {
    let request = {
      id : eventId,
      start: expectedDateToModify + ' ' + item.start.split(' ')[1],
      end: expectedDateToModify + ' ' + item.end.split(' ')[1],
      resourceId : item.resourceId
    }
    API.patch('/Event',request).then((response) => {
      doReload(!reload);
    });
  }

  function getRowStyle({ isSign, data }, arrTotalWorkTime) {
    const objStyle = {};
    const reducer = (final, now) => (final
      && now.actualSignInTime !== null
      && now.actualSignOutTime !== null);

    const buckyreducer = (final, now) => (final
      && now.actualSignInTime !== ''
      && now.actualSignOutTime !== '');
    if (isSign) {
      objStyle.backgroundColor = '#FA8072';
    } else if (arrTotalWorkTime[0] > 9) {
      objStyle.backgroundColor = '#fac472';
    } else if (!data.reduce(reducer, true)) {
      objStyle.backgroundColor = '#fac472';
    } else if (!data.reduce(buckyreducer, true)) {
      objStyle.backgroundColor = '#fac472';
    }
    return objStyle;
  }
  function calculateTotalWorkTime (totalWorkTime){
    var hourMinuteArr = Math.trunc(totalWorkTime);
    var decimals = totalWorkTime % 1;
    var newMinute = 0
    if(decimals < 1 && decimals >= 0.5)
      newMinute = 5;
    //return totalWorkTime;
    return `${hourMinuteArr}.${newMinute}`;
  }


  const wholeTime = (a, b, c) => {
    let parta = [];
    let partb = [];
    let partc = [];
    let hourTotal = 0;
    let minTotal = 0;
    if(a){
      parta = a.split(":");
    }
    if(b){
      partb = b.split(":");
    }
    if(c){
      partc = c.split(":");
    }
    
    if(parta.length > 1 && partb.length > 1)
    {
      minTotal = parseInt(parta[1]) + parseInt(partb[1]);
      if (minTotal >= 60){
        hourTotal =  parseInt(minTotal / 60) ;
        minTotal = minTotal % 60;
      }
      hourTotal = hourTotal + parseInt(parta[0]) + parseInt(partb[0]);
      if(partc.length > 1){
        minTotal = minTotal + parseInt(partc[1]);

        if (minTotal >= 60){
          hourTotal = hourTotal + parseInt(minTotal / 60) ;
          minTotal = minTotal % 60;
        }
        hourTotal = hourTotal + parseInt(partc[0]);

      }
    }

    // If using time pickers with 24 hours format, add the below line get exact hours
    // if (hours < 0)
    //    hours = hours + 24;

    return (hourTotal <= 9 ? "0" : "") + hourTotal + ":" + (minTotal <= 9 ? "0" : "") + minTotal;
  }

  const diff = (id, start, end) => { 
    start = start.split(':');
    end = end.split(':');
    var startDate = new Date(0, 0, 0, start[0], start[1], 0);
    var endDate = new Date(0, 0, 0, end[0], end[1], 0);
    var diff = endDate.getTime() - startDate.getTime();
    var hours = Math.floor(diff / 1000 / 60 / 60);
    diff -= hours * 1000 * 60 * 60;
    var minutes = Math.floor(diff / 1000 / 60);

    // If using time pickers with 24 hours format, add the below line get exact hours

    return (hours <= 9 ? "0" : "") + hours + ":" + (minutes <= 9 ? "0" : "") + minutes;
  }

  const delay = (expected, actual, all) =>{
    expected = expected.split(":");
    actual = actual.split(":");
    var expectedDate = new Date(0, 0, 0, expected[0], expected[1], 0);
    var actualDate = new Date(0, 0, 0, actual[0], actual[1], 0);
    if (actualDate <= expectedDate){
      return "0"
    }
    var diff = actualDate.getTime() - expectedDate.getTime();
    var hours = Math.floor(diff / 1000 / 60 / 60);
    diff -= hours * 1000 * 60 * 60;
    var minutes = Math.floor(diff / 1000 / 60);
    if (hours < 0)
    hours = hours + 24;
    return (<span style={{color:'red'}}>{(hours <= 9 ? "0" : "") + hours + ":" + (minutes <= 9 ? "0" : "") + minutes}</span>);

  }
  const checkDelay = (expected, actual, all) =>{
    expected = expected.split(":");
    actual = actual.split(":");
    var expectedDate = new Date(0, 0, 0, expected[0], expected[1], 0);
    var actualDate = new Date(0, 0, 0, actual[0], actual[1], 0);
    if (actualDate <= expectedDate){
      return "0"
    }
    var diff = actualDate.getTime() - expectedDate.getTime();
    var hours = Math.floor(diff / 1000 / 60 / 60);
    diff -= hours * 1000 * 60 * 60;
    var minutes = Math.floor(diff / 1000 / 60);
    if (hours < 0)
    hours = hours + 24;
    return {hours, minutes}

  }

  function leaveRecBtn(leaveRec){
    return (<button
      key={leaveRec.id}
      style={{width:'70px',height:'30px'}}
      type="button"
      className={`btn btn-md m-l-16 m-r-16 ${leaveRec.status === '1' ? "success" : "slide-bar-font-color-active"}`}
      onClick={() => {
        toggleLeaveRecDetailDisplay(
          leaveRec,
        );
      }}
    >
      <span>假單</span>
    </button>);
  }
  function toggleLeaveRecDetailDisplay(leaveRec) {
    if (isLeaveRecDetailDisplay){
      setTargetLeaveRec({});
    }else{
      setTargetLeaveRec(leaveRec);
    }
    toggleLeaveRecDetail(!isLeaveRecDetailDisplay)
  }
  var personalInfo = '';
  if(searchName && recordList.length > 0){
    personalInfo = (<table  className="u-table u-table-border u-table-striped">
        <tbody>
            <tr>
            <td className="sum-header">應上時數</td>
            <td>{personalSum.totalExpect||0}小時</td>
            <td className="sum-header">當月少上</td>
            <td>{personalSum.currentMonthLess||0}小時 </td>
            <td className="sum-header">總上班</td>
            <td>{personalSum.totalActual||0}小時 </td>
            <td className="sum-header">補休加班</td>
            <td>{personalSum.overtimeComp||0}小時</td>
            <td className="sum-header">加班費加班</td>
            <td>{personalSum.overtimePay||0}小時</td>
            <td className="sum-header">加班*1</td>
            <td className={`${firstRecord.status ? "" : "edit-area"}`}   onDoubleClick={()=>{handleDoubleClick(firstRecord.id, 'over2', personalSum.over2, firstRecord.name,'加班*1',firstRecord.status)}}>{personalSum.over2||0}小時</td>

            <td className="sum-header">加班*1.34</td>
            <td className={`${firstRecord.status ? "" : "edit-area"}`}  onDoubleClick={()=>{handleDoubleClick(firstRecord.id, 'over134', personalSum.over134, firstRecord.name,'加班*1.34',firstRecord.status)}}>{personalSum.over134||0}小時</td>
            <td className="sum-header">加班*1.67</td>
            <td className={`${firstRecord.status ? "" : "edit-area"}`}   onDoubleClick={()=>{handleDoubleClick(firstRecord.id, 'over167', personalSum.over167, firstRecord.name,'加班*1.67',firstRecord.status)}}>{personalSum.over167||0}小時</td>
            <td className="sum-header">加班*2.67</td>
            <td className={`${firstRecord.status ? "" : "edit-area"}`}   onDoubleClick={()=>{handleDoubleClick(firstRecord.id, 'over267', personalSum.over2, firstRecord.name,'加班*2.67',firstRecord.status)}}>{personalSum.over267||0}小時</td>

            <td className="sum-header">補休</td>
            <td>{personalSum.compLeave||0}小時</td>
            <td className="sum-header">特休</td>
            <td>{personalSum.annualLeave||0}小時</td>
            <td className="sum-header">請假</td>
            <td>{personalSum.normalLeave||0}小時</td>
            <td className="sum-header">遲到</td>
            <td>{personalSum.lateMin||0}分鐘</td>
            <td className="sum-header">剩餘補休</td>
            <td>{personalSum.remainCompensatoryHours||0}小時</td>
            <td className="sum-header">剩餘特休</td>
            <td>{personalSum.remainAnnualLeaveHours||0}小時</td>
            </tr>
        </tbody>
    </table>);
  }
  var lockBtn = '';
  if(role === '3'&& !isLock){
    lockBtn = (<button className="btn btn-md edit m-r-16" onClick={()=>{lockAllData()}}>鎖定資料</button>);
  }else if(role === '3'&& isLock){
    lockBtn = (<button className="btn btn-md success m-r-16" onClick={()=>{unlockAllData()}}>解鎖資料</button>);

  }
  var xlsnBtn = '';

  if(((role === '1' || role === '2')&& !isLock && new Date(year, month, 1) > new Date(2023, 5, 30) && recordList.length > 0)||(role === '2'&&new Date(year, month, 1) > new Date(2023, 5, 30) &&recordList ==0)){
    xlsnBtn = (<button className="btn btn-md edit m-r-16" onClick={() => { generateExcel(); } }>下載報表</button>);
  }

  return (
    
    <div className="p-signInManagement">

      <div className="u-block">
        <div className="u-title">員工出勤明細
        <a
              href="https://docs.google.com/presentation/d/10RB5_svavZPkS8Q5sjXplIOOxgqZLZGBX1CqIbMNpl0/edit#slide=id.g10b0e509c7e_0_45"
              className="u-how-use"
              target="_blank"
              rel="noopener noreferrer"
            >
              <i className="fas fa-question-circle" />
          </a>
        </div>

        <div className="sign-notice">
        <div className="u-notice">*溫馨提醒: </div>
        <div className="u-notice">米黃色欄位連點兩下可以對資料進行編輯，未顯示米黃色表示已鎖定資料不可修改。 </div>
        <div className="u-notice">欲解除鎖定資料，請聯絡工程人員。 </div>
        <div className="u-notice">此處修改不會變更到原始排班相關資料，僅作用在這個表單。 </div>
        <div className="u-notice">可編輯項目：預期簽到、預期簽退、簽到退一二、總工時(時、分)、加班、請假、遲到跟休息。 </div>
        <div className="u-notice">如果人工資料更新後，已在此表修改後資料會還原。</div>
        <div className="u-notice">當月少上=應上時數 - (總工時＋特休＋補休＋請假時數-補休加班(核)-加班費加班(核))</div>
        </div>
        <div className="u-search-box">
          {lockBtn}
          <div className="u-search-box_left">
            <div className="date-input">
              <select onChange={(e)=>{setYear(e.target.value)}} value={year} className="u-form__select">
              {
                yearNames.map(yearName => (
                  <option key={yearName} value={yearName}>{ yearName }</option>
                ))
              }
              </select>
              <span className="mobile-hide" style={{ flex: '0 0 20px' }}>年</span>

            </div>
            <div className="date-input">
              <select onChange={(e)=>{setMonth(e.target.value)}}  value={month} className="u-form__select">

                        {
                Array.from({ length: 12 }, (_, month) => (
                    <option value={month} key={month}>
                        {month + 1}
                    </option>
                ))
                }
              </select>
              <span className="mobile-hide" style={{ flex: '0 0 20px' }}>月</span>

            </div>
            
          {xlsnBtn}
          </div>
          <div className="u-search-box_right">
          <div className="date-input">
          <span className="mobile-hide"style={{ flex: '0 0 0px' }}>人員：</span>

            <select style={{minWidth:"56px"}} value={searchName} onChange={(e)=>{
                if(e.target.value === ''){
                    setSearchName(e.target.value); 
                    setCountOfPage(10)
                    setCurrPage(1)
                }else{
                    setSearchName(e.target.value); 
                    setCountOfPage(100)
                    setCurrPage(1)
                }

                }} className="u-form__select">
            <option  value={''} key={-1}>全部</option>

            {
                staffList.map(staff => (
                    <option key={staff.userId} value={staff.userName}>{ staff.userName }</option>
                  ))
            }
            </select>
          </div>
          </div>
        </div>
        <div className="u-table-responsive">
        {personalInfo}
          <table className="u-table u-table-border u-table-striped" id="myTable">
            <thead>
              <tr>
                <th>Id</th>
                <th>職稱</th>
                <th>兼職否</th>
                <th>姓名</th>
                <th>預計上班日</th>
                <th>預期簽到</th>
                <th>預期簽退</th>
                <th>簽到一</th>
                <th>簽退一</th>
                <th>簽到二</th>
                <th>簽退二</th>
                <th>總工時</th>
                <th>補休加班(核)</th>
                <th>加班費加班(核)</th>
                <th>請假</th>
                <th>遲到</th>
                <th>休息(分)</th>
                <th>總工時(時)</th>
                <th>總工時(分)</th>
                <th>簽核人</th>
                <th>簽核結果</th>
                <th>備註</th>

              </tr>
            </thead>
            <tbody>
              {
                recordList.map((item, index) => (
                  <tr key={index}>
                    <td>{item.userId}</td>
                    <td>{item.jobName}</td>
                    <td>{item.isPartTime}</td>
                    <td>{item.name}</td>
                    <td>{item.date.split('T')[0]}</td>
                    <td className={`${item.status ? "" : "edit-area"}`} onDoubleClick={()=>{handleDoubleClick(item.id, 'estSignIn', item.estSignIn, item.name + '-' + item.date.split('T')[0],'預期簽到',item.status)}}>{item.estSignIn}</td>
                    <td className={`${item.status ? "" : "edit-area"}`} onDoubleClick={()=>{handleDoubleClick(item.id, 'estSignOut', item.estSignOut, item.name + '-' + item.date.split('T')[0],'預期簽退',item.status)}}>{item.estSignOut}</td>
                    <td className={`${item.status ? "" : "edit-area"}`} onDoubleClick={()=>{handleDoubleClick(item.id, 'signIn1', item.signIn1, item.name + '-' + item.date.split('T')[0],'簽到一',item.status)}}>{item.signIn1}</td>
                    <td className={`${item.status ? "" : "edit-area"}`} onDoubleClick={()=>{handleDoubleClick(item.id, 'signOut1', item.signOut1, item.name + '-' + item.date.split('T')[0],'簽退一',item.status)}}>{item.signOut1}</td>
                    <td className={`${item.status ? "" : "edit-area"}`} onDoubleClick={()=>{handleDoubleClick(item.id, 'signIn2', item.signIn2, item.name + '-' + item.date.split('T')[0],'簽到二',item.status)}}>{item.signIn2}</td>
                    <td className={`${item.status ? "" : "edit-area"}`} onDoubleClick={()=>{handleDoubleClick(item.id, 'signOut2', item.signOut2, item.name + '-' + item.date.split('T')[0],'簽退二',item.status)}}>{item.signOut2}</td>
                    <td className={`${item.status ? "" : "edit-area"}`} onDoubleClick={()=>{handleDoubleClick(item.id, 'totalHours', item.totalHours, item.name + '-' + item.date.split('T')[0],'總工時',item.status)}}>{item.totalHours}</td>
                    <td className={`${item.status ? "" : "edit-area"}`} onDoubleClick={()=>{handleDoubleClick(item.id, 'compensatoryHours', item.compensatoryHours, item.name + '-' + item.date.split('T')[0],'補休加班(核)',item.status)}}>{item.compensatoryHours}</td>
                    <td className={`${item.status ? "" : "edit-area"}`} onDoubleClick={()=>{handleDoubleClick(item.id, 'payHours', item.payHours, item.name + '-' + item.date.split('T')[0],'加班費加班(核)',item.status)}}>{item.payHours}</td>
                    <td className={`${item.status ? "" : "edit-area"}`} onDoubleClick={()=>{handleDoubleClick(item.id, 'leaveHours', item.leaveHours, item.name + '-' + item.date.split('T')[0],'請假',item.status)}}>{item.leaveHours}</td>
                    <td className={`${item.status ? "" : "edit-area"}`} onDoubleClick={()=>{handleDoubleClick(item.id, 'lateMin', item.lateMin, item.name + '-' + item.date.split('T')[0],'遲到',item.status)}}>{item.lateMin}</td>
                    <td className={`${item.status ? "" : "edit-area"}`} onDoubleClick={()=>{handleDoubleClick(item.id, 'breakTimeMin', item.breakTimeMin, item.name + '-' + item.date.split('T')[0],'休息(分)',item.status)}}>{item.breakTimeMin}</td>
                    <td className={`${item.status ? "" : "edit-area"}`} onDoubleClick={()=>{handleDoubleClick(item.id, 'totalHoursH', item.totalHoursH, item.name + '-' + item.date.split('T')[0],'總工時(時)',item.status)}}>{item.totalHoursH}</td>
                    <td className={`${item.status ? "" : "edit-area"}`} onDoubleClick={()=>{handleDoubleClick(item.id, 'totalHoursM', item.totalHoursM, item.name + '-' + item.date.split('T')[0],'總工時(分)',item.status)}}>{item.totalHoursM}</td>
                    <td>{item.approverEmp}</td>
                    <td>{item.approver}</td>
                    <td className={`${item.status ? "" : "edit-area"}`} onDoubleClick={()=>{handleDoubleClick(item.id, 'notes', item.notes, item.name + '-' + item.date.split('T')[0],'備註',item.status)}}>{item.notes}</td>

                  </tr>
                ))
              }
            </tbody>
          </table>
        </div>
        <div className="pagination-box">
          <Pagination
            currPage={currPage}
            totalPage={totalPage}
            onChangPage={handleChangePage}
          />
        </div>

      </div>
      <LeaveRecDetail 
            leaveRec={targetLeaveRec}
            isShow={isLeaveRecDetailDisplay}
            toggleFunc={toggleLeaveRecDetailDisplay}
          />
      <AddWorkTimeInSignInShiftBlock 
          isSalaryEdit={true}
          isVisible={isAddWorkTimeOpen} 
          toggleOpen={()=>{setIsAddWorkTimeOpen(false)}} 
          allStaff={staffList} 
          editStaff={editStaff}
          saveWorkRecordFunc={handleAddStaffWorkRecord}
        />
    </div>
  );
}

export default MonthHour;
